import { useNavigate } from "react-router";
import { Col } from "reactstrap";
import { H3, LI, UL } from "../../../../AbstractElements";
import { ContinueShopping, Href, Product, Total } from "../../../../Constant";
import { useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import { getallCardTotal } from "../../../../Service/Ecommerce.service";
import CartData from "./CartData";
import ShippingOptions from "./ShippingOptions";
import PaymentOptions from "./PaymentOptions";

const ProductPlaceOrder = () => {
  const Navigate = useNavigate();
  const { cart } = useAppSelector((state) => state.cartData);

  const handleNavigate = () => Navigate(`${process.env.PUBLIC_URL}/ecommerce/product`);
  return (
    <Col xl="6" sm="12">
      <div className="checkout-details">
        <div className="order-box">
          <div className="title-box">
            <div className="checkbox-title">
              <H3 className="f-w-700">{Product}</H3>
              <span  className="f-w-700">{Total}</span>
            </div>
          </div>
          <CartData />
          <ShippingOptions />
          <UL className="simple-list sub-total total">
            <LI>{Total}<span className="count">$ {getallCardTotal(cart)}</span></LI>
          </UL>
          <PaymentOptions />
          <div className="mt-2 d-flex justify-content-between">
            <a href={Href} className="btn btn-primary text-white me-2 text-capitalize"
              onClick={(e) => { e.preventDefault(); handleNavigate()}}>{ContinueShopping}
            </a>
          </div>
        </div>
      </div>
    </Col>
  );
};
export default ProductPlaceOrder;
